<template>
  <div class="user-process-wrapper">
    <div class="title-with-icons">
      <div class="left">
        <div class="title">{{ title }}</div>
        <div class="actionIcons">
          <div @click="emitRefreshWithAlert">
            <i class="fas fa-sync-alt refresh-list-icon"></i>
          </div>

          <div @click="downloadTableData()">
            <i class="fas fa-download"></i>
          </div>
        </div>
      </div>
      <search-input
        :defaultValue="searchValue"
        placeholder="Szukaj po numerze telefonu..."
        @search="newSearchValue"
      />
      <!-- <custom-select-with-checkboxes
        :placeholder="'Filtr'"
        :options="[
          {
            value: 'NOT_FINISHED',
            name: 'Rozpoczęta płatność',
            shortName: 'Rozpoczęta płatność',
          },
          {
            value: 'NOT_STARTED',
            name: 'N-rozpoczęta płatność',
            shortName: 'N-rozpoczęta płatność',
          },
        ]"
      /> -->
    </div>

    <div class="process-windows">
      <div :key="type" v-for="{ type, title } in boxTypes">
        <user-process-window
          :type="type"
          :title="title"
          @process-chosen="newProcessChosen"
          @refresh="emitRefresh"
          :ratio="allSuccess.rate"
          :data="
            type === 'todo'
              ? allToDo.userProcesses
              : type === 'done'
              ? allDone.userProcesses
              : type === 'success'
              ? allSuccess.userProcesses
              : allLost.userProcesses
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
// import CustomSelectWithCheckboxes from "./CustomSelectWithCheckboxes.vue";
import UserProcessWindow from "./UserProcessWindow.vue";
import SearchInput from "@/components/SearchInput";
import axios from "../axios";
export default {
  components: { UserProcessWindow, SearchInput },
  name: "UserProcessWrapper",
  props: ["title"],
  emits: ["refresh", "process-chosen", "refresh-with-alert"],
  data() {
    return {
      searchValue: "",
      boxTypes: [
        {
          title: "Do zrobienia",
          type: "todo",
        },
        {
          title: "Zrobione",
          type: "done",
        },
        {
          title: "Sukces",
          type: "success",
        },
        {
          title: "Stracone",
          type: "danger",
        },
      ],
    };
  },
  mounted() {
    const queries = this.$router.currentRoute.query;
    if (queries.search) this.searchValue = queries.search;
    else this.searchValue = "";
  },
  watch: {
    $route() {
      if (this.$router.currentRoute.query.search != this.searchValue) {
        this.searchValue = this.$router.currentRoute.query.search;
      }
    },
  },

  methods: {
    async downloadTableData() {
      try {
        const response = await axios("/api/admin/userProcesses/file", {
          method: "GET",
          headers: {
            "Content-Disposition": `attachment; filename=user_processes.xls`,
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "blob",
        });

        if (response) {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "user_processes.xls");
          document.body.appendChild(fileLink);
          fileLink.click();
        }
      } catch (error) {
        console.log(error);
      }
    },

    emitRefresh() {
      this.$emit("refresh");
    },
    emitRefreshWithAlert() {
      this.$emit("refresh-with-alert");
    },
    newProcessChosen(e) {
      this.$emit("process-chosen", e);
    },
    async newSearchValue(e) {
      console.log(e);
      this.searchValue = e;
      const queries = this.$router.currentRoute.query;
      let filterBy = "";
      let filterWith = "";
      let filterBySecond = "";
      let filterWithSecond = "";
      let type = "";
      if (queries.type) type = queries.type;
      if (queries.filterBy) filterBy = queries.filterBy;
      if (queries.filterWith) filterWith = queries.filterWith;
      if (queries.filterBySecond) filterBySecond = queries.filterBySecond;
      if (queries.filterWithSecond) filterWithSecond = queries.filterWithSecond;

      this.$router.push({
        name: "UserProcess",
        query: {
          type: type,
          filterWith: filterWith,
          filterBy: filterBy,
          filterWithSecond: filterWithSecond,
          filterBySecond: filterBySecond,
          search: this.searchValue,
        },
      });
      this.emitRefresh();
    },
  },
  computed: {
    allToDo() {
      return this.$store.getters.getToDo;
    },
    allDone() {
      return this.$store.getters.getDone;
    },
    allSuccess() {
      return this.$store.getters.getSuccess;
    },
    allLost() {
      return this.$store.getters.getLost;
    },
  },
};
</script>

<style scoped>
.process-windows {
  display: flex;
  flex-wrap: wrap;
  /* align-items: center;
  justify-content: center; */
}
.user-process-wrapper {
  width: 100vw;
  max-width: 1450px;
}
.title {
  font-size: 28px;
  font-weight: 600;
  color: #090741;
}
.actionIcons {
  max-width: 100px;
  display: flex;
  margin-top: 6px;
  margin-left: 10px;
}
.actionIcons div {
  margin: 0;
  height: 20px;
  cursor: pointer;
  border: 1px solid #e5e5e9;
  padding: 5px 20px 5px 20px;
  color: #cccccf;
  min-height: 30px;
}
.actionIcons div:hover {
  color: #000;
}
.title-with-icons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 150px;
}
.title-with-icons .left {
  display: flex;
}
</style>
